
import React from "react";
import { usePriceContext } from "@/context/PriceContext";
import { LoaderCircle, RefreshCw, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

export const ConnectionStatusBanner = () => {
  const { isConnected, reconnectingStatus, reconnect } = usePriceContext();
  
  if (isConnected) return null;
  
  return (
    <div 
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50 px-4 py-2 transform transition-transform duration-300",
        reconnectingStatus ? "translate-y-0" : "translate-y-full"
      )}
    >
      <Alert variant="destructive" className="flex items-center justify-between">
        <div className="flex items-center">
          {reconnectingStatus ? (
            <>
              <LoaderCircle className="h-4 w-4 mr-2 animate-spin" />
              <AlertDescription>
                Reconnecting to server...
              </AlertDescription>
            </>
          ) : (
            <>
              <WifiOff className="h-4 w-4 mr-2" />
              <AlertDescription>
                Connection lost. Please reconnect.
              </AlertDescription>
            </>
          )}
        </div>
        
        <Button 
          size="sm" 
          variant="outline" 
          className="ml-2 bg-background"
          onClick={() => {
            reconnect();
            window.location.reload();
          }}
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Reconnect
        </Button>
      </Alert>
    </div>
  );
};
